export type MedSection =
  | 'early_morning'
  | 'workout'
  | 'breakfast'
  | 'lunch'
  | 'dinner'
  | 'evening'
  | 'bedtime'
  | 'other';

export const SECTION_ORDER: MedSection[] = [
  'early_morning',
  'workout',
  'breakfast',
  'lunch',
  'dinner',
  'evening',
  'bedtime',
  'other',
];

const SECTION_META: Record<MedSection, { label: string; emoji: string | null }> = {
  early_morning: { label: 'Раннее утро', emoji: '🌙' },
  workout:       { label: 'Тренировка',  emoji: '🏃' },
  breakfast:     { label: 'Завтрак',     emoji: null },
  lunch:         { label: 'Обед',        emoji: null },
  dinner:        { label: 'Ужин',        emoji: null },
  evening:       { label: 'Вечер',       emoji: null },
  bedtime:       { label: 'Сон',         emoji: '💤' },
  other:         { label: 'Другое',      emoji: null },
};

export function sectionLabel(s: MedSection): string {
  return SECTION_META[s].label;
}

export function sectionEmoji(s: MedSection): string | null {
  return SECTION_META[s].emoji;
}
